export default "src/content/themes/association-wordpress-theme/img/fd3c79a48dcac1b4148395fa359cda0b.png";